import { Block } from 'components/Block'
import { GuidebookStep, stepLovedOneData } from 'components/content/guidebook/content'
import { GuidebookArticleCard } from 'components/content/guidebook/guidebookArticleCard/GuidebookArticleCard'
import { GuidebookStepHeader } from 'components/content/guidebook/guidebookStepHeader/GuidebookStepHeader'
import { SGridWrapper } from './GuidebookStepLovedOne.styled'
import { Spacer } from 'components/spacer/Spacer'
import { Trans, useTranslation } from 'next-i18next'
import { numberRange } from 'utils/general'
import { PrimaryFakeLink } from 'components/Link'

export function GuidebookStepLovedOne(props: { step: GuidebookStep }) {
  const { t } = useTranslation('eol_guide')

  return (
    <>
      <GuidebookStepHeader step={props.step} description={t('eol_guide.step_5.description')} />
      <Spacer size={2} />
      <Block>
        <SGridWrapper>
          {numberRange(5).map((i) => (
            <GuidebookArticleCard
              key={i}
              title={t(`eol_guide.step_5.item_${i}.title`)}
              description={
                <Trans
                  t={t}
                  i18nKey={`eol_guide.step_5.item_${i}.description`}
                  components={{ emptyLink: <PrimaryFakeLink /> }}
                />
              }
              {...stepLovedOneData[i]}
            />
          ))}
        </SGridWrapper>
      </Block>
    </>
  )
}
